import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { cuesApi, definitions } from "./imports";

export default function CueEditContentWrapper({ cue }) {
	const { projectId } = useParams();

	const GraphicEditor = definitions[cue.type].components.GraphicEditor;

	const media =
		useSelector((state) => state.main?.projects?.[projectId]?.media) || [];
	const dataSources = useSelector((state) => state.main?.dataSources) || {};

	const handleOnUpdate = (update) => {
		cuesApi.updateCue(cue.id, projectId, update);
	};

	return (
		<GraphicEditor
			cue={cue}
			media={media}
			onUpdate={handleOnUpdate}
			dataSources={dataSources}
		/>
	);
}
